export default __webpack_public_path__ + "static/media/logo-large.9f70159d.png";